
import { 
  Paper, 
  Typography, 
  Avatar, 
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider 
} from '@mui/material';

export default function UserProfile({ user }) {
  return (
    <Paper sx={{ p: 3, width: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
        <Avatar 
          sx={{ width: 100, height: 100, mb: 2 }}
          src={user.avatarUrl} 
          alt={user.name}
        />
        <Typography variant="h5" gutterBottom>
          {user.name}
        </Typography>
        <Typography color="textSecondary" gutterBottom>
          {user.email}
        </Typography>
      </Box>
      
      <List>
        <ListItem>
          <ListItemText 
            primary="Member Since" 
            secondary={new Date(user.$createdAt).toLocaleDateString()} 
          />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText 
            primary="Last Active" 
            secondary={new Date(user.$updatedAt).toLocaleDateString()} 
          />
        </ListItem>
      </List>
    </Paper>
  );
}
